import { without as _without } from 'lodash-es';

import {
  TUTORIAL_ANY_PAGE_MISSIONS_COMPLETED,
  COUPON_MODAL_SHOW,
  COUPON_MODAL_HIDE,
  REQUEST_FAILED,
  ERROR_MODAL_SHOW,
  ERROR_MODAL_HIDE,
  CLOSE_OTHER_MODALS
} from '../definitions/events.ts';

// Vue related events.
export default function ($root) {
  // any page
  // coupon management

  $root.$on(TUTORIAL_ANY_PAGE_MISSIONS_COMPLETED, (pageNumber, pageCount) => {
    const isFreePlan =
      $root.$store.state.CodementumUser.account.paymentType === 'FREE';
    const showCouponModals = isFreePlan;
    if (showCouponModals) {
      const isLastPageEntered = pageNumber === pageCount - 1;

      if (pageNumber === 2) {
        $root.$emit(COUPON_MODAL_SHOW, {
          couponCode: 'ALLPLANS-15-TSA5',
          discount: '15%'
        });
      }
      if (pageNumber === 5) {
        $root.$emit(COUPON_MODAL_SHOW, {
          couponCode: 'ALLPLANS-20-KCS3',
          discount: '20%'
        });
      }
      if (isLastPageEntered) {
        $root.$emit(COUPON_MODAL_SHOW, {
          couponCode: 'ALLPLANS-20-KCS3',
          discount: '20%',
          notice:
            'You have reached the end of the trial version. You can continue your coding advanture from where you left off in an advantageous way by using the following discount coupon specially prepared for you.',
          skip: false
        });
      }
    }
  });

  $root.$on(REQUEST_FAILED, (errorMessage) => {
    // message: "Insufficient permission : User's package does not cover this page. userUuid= xxx, pageNumber= y"

    const IsUserHasNoScope = errorMessage.includes(
      "User's package does not cover this page"
    );

    if (IsUserHasNoScope) {
      $root.$emit(CLOSE_OTHER_MODALS, ERROR_MODAL_HIDE);
      $root.$emit(ERROR_MODAL_SHOW, {
        notice:
          'Your plan does not contain accessing the resource. Please update your plan or contact us if you think that there is a problem.'
      });
    }
  });

  // Close all modals except one.
  $root.$on(CLOSE_OTHER_MODALS, (except) => {
    const events = _without([COUPON_MODAL_HIDE, ERROR_MODAL_HIDE], except);

    events.forEach((event) => {
      $root.$emit(event);
    });
  });

  $root.$on(COUPON_MODAL_SHOW, ({ discount }) => {
    // send email to principle
    $root.$store.getters['CodementumUser/apiRequest']({
      method: 'post',
      // backend made enum.
      path: 'user/mail/DISCOUNT' + discount.replace('%', '')
    });
  });
}
